const SkeletonLoader = ({ count = 6 }) => {
	return (
		<div className="vayu-template-grid-skeleton">
			{Array.from({ length: count }).map((_, i) => (
				<div key={i} className="vayu-skeleton-card" aria-hidden="true"/>
			))}
		</div>
	);
};

export default SkeletonLoader;
